import styled from "styled-components/native";
import Title from "../Text";
import { font, text } from "../theme";

export const SmallTitle = styled(Title)`
  font-family: ${font.defaultMedium};
  font-size: ${text.medium.size};
`;
